export const HOST_NAME = "https://cable.dawaadost.com/abdm";

export const PORT = "";
export const VERSION = "v1";
export var URI_PREFIX = `${HOST_NAME}`;
// export var URI_PREFIX = `${HOST_NAME}:${PORT}`;

export function getHost() {
  return URI_PREFIX;
}
export var URI = getURI();
export function getURI() {
  return {
    //-----------------------------------------------------------------Dev, Access-----------------------------------------------------------------------------------
    //To generate the web token for accessing all the features(Transactional) like OTP generation and validation inside the ABDM app.
    generateWebAccessToken: `${getHost()}/${VERSION}/generate/web/token`,
    heartbeat: `${getHost()}/v0.5/heartbeat`,
    //To validate the Token on the start of the app.
    validateReactOpenToken: `${getHost()}/${VERSION}/validate/token`,
    //To check whether ABDM Server has sent data to our application as per our User requirements
    getWebhookResponse: `${getHost()}/${VERSION}/webhook-response`,

    //-------------------------------------------------------------------M1: Generate ABHA--------------------------------------------------------------------------
    // generateOTP: `${getHost()}/${VERSION}/registration/mobile/generateOtp`,
    // generateHealthId: `${getHost()}/${VERSION}/registration/mobile/generateHealthId`,
    // healthId: `${getHost()}/${VERSION}/search/findHealthIdByMobileNo`,
    // resendOTP: `${getHost()}/${VERSION}/registration/mobile/resendOtp`,

    //To send OTP to the mobile number registered with the given Aadhaar Number for New Abha Registration.
    generateAdhaarOTP: `${getHost()}/${VERSION}/registration/aadhaar/generateOtp`,

    resendAdhaarOTP: `${getHost()}/${VERSION}/registration/aadhaar/resendOtp`,

    //To Verify the entered OTP for new Abha Registration with Aadhar Number
    verifyAadhaarOtp: `${getHost()}/${VERSION}/registration/aadhaar/verifyOTP`,

    //To Send OTP to the user given mobile number for new Abha Registration.
    generateMobileOtpForAadhaarRegistration: `${getHost()}/${VERSION}/registration/aadhaar/generateMobileOTP`,

    //To Verify the OTP send to the user given Mobile number for New Abha Registration.
    verifyMobileOtpForAadhaarRegistration: `${getHost()}/${VERSION}/registration/aadhaar/verifyMobileOTP`,

    generateAdhaarHealthId: `${getHost()}/${VERSION}/registration/aadhaar/generateHealthId`,

    //To create ABHA ID based on the given details and populate the user details in the details(next) page
    generateAdhaarAbhaId: `${getHost()}/${VERSION}/registration/aadhaar/createHealthIdWithPreVerified`,

    //-------------------------------------------------------------------M1: Verify ABHA--------------------------------------------------------------------------
    //To Generate OTp Based on the Auth Mode on the Verify Abha Component.
    authInit: `${getHost()}/${VERSION}/auth/init`,
    //To verify the generated OTP generated on basis of Aadhaar_OTP auth-mode selected in the previous step and proceed to next step.
    authConfirmWithAadhaarOtp: `${getHost()}/${VERSION}/auth/confirmWithAadhaarOtp`,
    //To verify the generated OTP generated on basis of Mobile_OTP auth-mode selected in the previous step and proceed to next step.
    authConfirmWithMobileOtp: `${getHost()}/${VERSION}/auth/confirmWithMobileOtp`,
    //Return the details of the user profile associated with the given ABHA Id after verification
    getProfile: `${getHost()}/${VERSION}/account/profile`,
    //To get the Health Card of the verified ABHA user
    getPngCard: `${getHost()}/${VERSION}/account/getPngCard`,

    //-------------------------------------------------------------------M2:(HIP Initiated)--------------------------------------------------------------------------
    userAuthFetchModes: `${getHost()}/${VERSION}/user/auth/fetchmodes`,
    //To initialize the process of authentication in care contex by selecting different care contexts and the mode of authentication.
    userAuthInit: `${getHost()}/${VERSION}/user/auth/init`,
    //To Authenticate the user after selection of care context on basis of Aadhar OTP and Mobile OTP.
    userAuthConfirm: `${getHost()}/${VERSION}/user/auth/confirm`,
    //To Authenticate user after selection of care context on the basis of Demographics mode of authentication
    userAuthDemographicsConfirm: `${getHost()}/${VERSION}/user/auth/demographics/confirm`,
    //To send all the details of Care-Context which are going to be linked.
    addCareContext: `${getHost()}/${VERSION}/carecontext/add`,
    //To fetch the different modes of Authentication of the user & show them in the add care context part.
    getFetchModes: `${getHost()}/${VERSION}/fetchmodes`,

    integratorGetCareContext: `${getHost()}/${VERSION}/integrator/getCareContext`,

    integratorUpdateCareContext: `${getHost()}/${VERSION}/integrator/updateCareContext`,

    //-------------------------------------------------------------------------M3----------------------------------------------------------------------------
    //To Find Patient Details for raising new Consents By the given ABHA ID
    patientFind: `${getHost()}/${VERSION}/patients/find`,
    //To Fetch the list of available consent that has been generated by the all the users till now
    getConsentList: `${getHost()}/${VERSION}/consents`,
    //To Fetch the Consent Artefact of the selected User from the Consent List
    getConsentArtefacts: `${getHost()}/${VERSION}/consent-artefacts`,
    findConsentArtefact: `${getHost()}/${VERSION}/consent-artefacts/find`,
    //To raise a Consent Request with respect to the details provided by the user.
    consentRequestInit: `${getHost()}/${VERSION}/consentrequests/init`,
    getConsentStatus: `${getHost()}/${VERSION}/consentrequests/status`,
    getPatientInfo: `${getHost()}/${VERSION}/patientinfo/get`,
    //To send Request to Consent Manager to share data about the selected User to the ABDM Application.
    healthInfoCmRequest: `${getHost()}/${VERSION}/healthinformation/cm/request`,

    getConsentArtefacts: `${getHost()}/${VERSION}/consent-artefacts`,

    decryptString: `${getHost()}/${VERSION}/decrypt`,

    //-------------------------------------------------------------------------------demoAuth APIs------------------------------------------------------------------------
    demoAuthGetStateList: `${getHost()}/connector/demoAuth/getState`,
    demoAuthGetDistrictList: `${getHost()}/connector/demoAuth/getDistrictByStateCode`,
    demoAuthCreateHealthId: `${getHost()}/connector/demoAuth/createHealthId/demo/auth`,
    demoAuthGetHealthCard: `${getHost()}/connector/demoAuth/getCard`,
    demoAuthGetProfile: `${getHost()}/connector/demoAuth/get/profile`,

    demoAuthCreateHealthIdV3: `${getHost()}/connector/v3/demoAuth/createHealthIdV3`,
    demoAuthGetHealthCardV3: `${getHost()}/connector/v3/demoAuth/getPngCardV3`,

    //-------------------------------------------------------------------------------v3.0 M1 Generate ABHA------------------------------------------------------------------
    v3sendAadhaarOtp: `${getHost()}/connector/v3/sendAadhaarOtpV3`,
    v3validateAadharOtp: `${getHost()}/connector/v3/validateAadhaarOtpV3`,
    v3changeMobileNumber: `${getHost()}/connector/v3/changeMobileNo`,
    v3verifyMobileNumberOtp: `${getHost()}/connector/v3/verifyMobileOtp`,
    v3getHealthIdSuggestion: `${getHost()}/connector/v3/getAbhaSuggestion`,
    v3saveNewHealthId: `${getHost()}/connector/v3/updateAbha`,

    //-------------------------------------------------------------------------------v3.0 M1 Verify ABHA---------------------------------------------------------------------
    v3authInit: `${getHost()}/connector/v3/verifyAbha/sendOTP`,
    v3authConfirm: `${getHost()}/connector/v3/verifyAbha/verifyOTP`,
    v3getVerifiedProfileApi1: `${getHost()}/connector/v3/verifyAbha/verifyUser`,
    v3getVerifiedProfileApi2: `${getHost()}/connector/v3/account/getProfile`,
    v3getHealthCard: `${getHost()}/connector/v3/account/getCard`,

    v3fetchAbha: `${getHost()}/connector/v3/find/Abha`,
    v3findAbhaSendOtp: `${getHost()}/connector/v3/login/request/otp`,
    v3findAbhaVerifyOtp: `${getHost()}/connector/v3/profile/login/verify`,
    v3findAbhaGetProfile: `${getHost()}/connector/v3/profile/account`,

    //-------------------------------------------------------------------------------v3.0 M1 Verify/Create ABHA via Mobile---------------------------------------------------------------------
    v3requestAbhaMobileOtp: `${getHost()}/connector/v3/abha/mobile/request/otp`,
    v3verifyAbhaMobileOtp: `${getHost()}/connector/v3/abha/mobile/otp/verify`,
    v3existingLoginUser: `${getHost()}/connector/v3/abha/mobile/verify/user`,
    v3newABHASuggestion: `${getHost()}/connector/v3/abha/mobile/enrollment/suggestion`,
    v3enrolABHAaddress: `${getHost()}/connector/v3/abha/mobile/enrollment/abha/enrol`,
    v3enrolABHAgetProfile: `${getHost()}/connector/v3/abha/mobile/profile/abha-profile`,
    v3enrolABHAgetPngCard: `${getHost()}/connector/v3/abha/mobile/phr-card`,

    //-------------------------------------------------------------------------------v3.0 M3 Consents API---------------------------------------------------------------------
    patientFind: `${getHost()}/${VERSION}/patients/find`,
    v3consentRequestInit: `${getHost()}/v3/consent/requests/init`,
    getConsentList: `${getHost()}/${VERSION}/consents`,
    v3healthInfoCmRequest: `${getHost()}/v3/healthinformation/cm/request`,
  };
}
